import { render } from "./MuddemalView.vue?vue&type=template&id=e4a715c0&scoped=true"
import script from "./MuddemalView.vue?vue&type=script&lang=js"
export * from "./MuddemalView.vue?vue&type=script&lang=js"

import "./MuddemalView.vue?vue&type=style&index=0&id=e4a715c0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4a715c0"]])

export default __exports__